import { combineReducers } from '@reduxjs/toolkit';
import providerReducer from '@/store/slices/provider.slice';
import operatorReducer from '@/store/slices/operator.slice';
import subapplicationSliceReducer from '@/store/slices/subApplication.slice';
import vdiTransactionReducer from '@/store/slices/vdiTransaction.slice';
import dashboardSliceReducer from '@/store/slices/dashboard.slice';
import quickPayMasterProductReducer from '@/store/slices/quickPay.slice';
import smartCoolerProductsReducer from '@/store/slices/smartCoolerProducts.slice';
import userReducer from '@/store/slices/user.slice';
import userRoleReducer from './slices/role.slice';
import locationReducer from './slices/locations.slice';
import marketReducer from './slices/market.slice';
import productReducer from './slices/product.slice';
import reconciliationReducer from './slices/reconciliation.slice';
import alertReducer from './slices/alert.slice';
import deviceReducer from './slices/device.slice';
import mmsSalesReducer from './slices/mmsSales.slice';
import cronJobsTrackerDataReducer from './slices/cronJobsTracker.slice';
import targetedReconciliationReducer from './slices/targetedReconciliation.slice';
import coolerTransactionReducer from './slices/coolerTransaction.slice';
import approvedProductsReducer from './slices/approvedProducts.slice';
import appLogsReducer from './slices/appLogs.slice';
import smartCoolerReducer from './slices/smartCooler.slice';

const rootReducer = combineReducers({
  dashboard: dashboardSliceReducer,
  provider: providerReducer,
  operator: operatorReducer,
  subapplication: subapplicationSliceReducer,
  vdiTransaction: vdiTransactionReducer,
  quickPayMasterProduct: quickPayMasterProductReducer,
  smartCoolerProducts: smartCoolerProductsReducer,
  user: userReducer,
  role: userRoleReducer,
  location: locationReducer,
  market: marketReducer,
  product: productReducer,
  reconciliation: reconciliationReducer,
  alert: alertReducer,
  mmsSales: mmsSalesReducer,
  devices: deviceReducer,
  cronJobsTracker: cronJobsTrackerDataReducer,
  targetedReconciliation: targetedReconciliationReducer,
  coolerTransaction: coolerTransactionReducer,
  approvedProducts: approvedProductsReducer,
  appLogs: appLogsReducer,
  smartCooler: smartCoolerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
